var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowFillUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.00 48.00",
    "data-guides": "{\"vertical\":[],\"horizontal\":[]}",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24cd73",
    stroke: "#24cd73",
    fillOpacity: 1,
    strokeWidth: 2,
    strokeOpacity: 1,
    alignmentBaseline: "baseline",
    baselineShift: "baseline",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "cls-1",
    id: "tSvg159236ca9a0",
    title: "Path 1",
    d: "M41.14 24C38.0933 24 35.0467 24 32 24C32 31.6667 32 39.3333 32 47C26.6667 47 21.3333 47 16 47C16 39.3333 16 31.6667 16 24C12.9533 24 9.9067 24 6.86 24C12.5733 16.3333 18.2867 8.6667 24 1C29.7133 8.6667 35.4267 16.3333 41.14 24Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFillUp);
export default __webpack_public_path__ + "static/media/arrow-fill-up.e4f3859f0366512f458e5ef25447a0c2.svg";
export { ForwardRef as ReactComponent };